module.exports = __webpack_public_path__ + "img/burrito.2b454277.svg";